import _defineProperty from "/builder/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/builder/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builder/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builder/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builder/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _createForOfIteratorHelper from '@babel/runtime/helpers/esm/createForOfIteratorHelper';
import _applyDecoratedDescriptor from '@babel/runtime/helpers/esm/applyDecoratedDescriptor';
import { extension, ExtensionPriority, command, NodeExtension, object, isPlainObject, entries } from '@remirror/core';
import { Step, StepResult } from '@remirror/pm/transform';

var _dec, _dec2, _class, _class2;

var DocExtension = (_dec = extension({
  defaultOptions: {
    content: 'block+',
    docAttributes: []
  },
  defaultPriority: ExtensionPriority.Medium,
  staticKeys: ['content', 'docAttributes'],
  disableExtraAttributes: true
}), _dec2 = command(), _dec(_class = (_class2 = /*#__PURE__*/function (_NodeExtension) {
  _inherits(DocExtension, _NodeExtension);

  var _super = _createSuper(DocExtension);

  function DocExtension() {
    _classCallCheck(this, DocExtension);

    return _super.apply(this, arguments);
  }

  _createClass(DocExtension, [{
    key: "name",
    get: function get() {
      return 'doc';
    }
    /**
     * Create the node spec for the `doc` the content that you've provided.
     */

  }, {
    key: "createNodeSpec",
    value: function createNodeSpec(_, override) {
      var _this$options = this.options,
          docAttributes = _this$options.docAttributes,
          content = _this$options.content;
      var attrs = object();

      if (isPlainObject(docAttributes)) {
        var _iterator = _createForOfIteratorHelper(entries(docAttributes)),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _step$value = _slicedToArray(_step.value, 2),
                key = _step$value[0],
                value = _step$value[1];

            attrs[key] = {
              default: value
            };
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else {
        var _iterator2 = _createForOfIteratorHelper(docAttributes),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _key = _step2.value;
            attrs[_key] = {
              default: null
            };
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }

      return _objectSpread({
        attrs: attrs,
        content: content
      }, override);
    }
    /**
     * Update the attributes for the doc node.
     */

  }, {
    key: "setDocAttributes",
    value: function setDocAttributes(attrs) {
      return function (_ref) {
        var tr = _ref.tr,
            dispatch = _ref.dispatch;

        if (dispatch) {
          for (var _i = 0, _Object$entries = Object.entries(attrs); _i < _Object$entries.length; _i++) {
            var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
                key = _Object$entries$_i[0],
                value = _Object$entries$_i[1];

            tr.step(new SetDocAttributeStep(key, value));
          }

          dispatch(tr);
        }

        return true;
      };
    }
  }]);

  return DocExtension;
}(NodeExtension), _applyDecoratedDescriptor(_class2.prototype, "setDocAttributes", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "setDocAttributes"), _class2.prototype), _class2)) || _class);
var STEP_TYPE = 'SetDocAttribute';
var REVERT_STEP_TYPE = 'RevertSetDocAttribute';
/**
 * A transaction step for updating the top level `doc` node attributes.
 *
 * This is required as mentioned in this discussion
 * https://discuss.prosemirror.net/t/changing-doc-attrs/784/17
 */

var SetDocAttributeStep = /*#__PURE__*/function (_Step) {
  _inherits(SetDocAttributeStep, _Step);

  var _super2 = _createSuper(SetDocAttributeStep);

  /**
   * The attribute key.
   */
  function SetDocAttributeStep(key, value) {
    var _this;

    _classCallCheck(this, SetDocAttributeStep);

    var stepType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : STEP_TYPE;
    _this = _super2.call(this);
    _this.stepType = stepType;
    _this.key = key;
    _this.value = value;
    return _this;
  }

  _createClass(SetDocAttributeStep, [{
    key: "apply",
    value: function apply(doc) {
      this.previous = doc.attrs[this.key];

      var attrs = _objectSpread(_objectSpread({}, doc.attrs), {}, _defineProperty({}, this.key, this.value));

      return StepResult.ok(doc.type.create(attrs, doc.content, doc.marks));
    }
  }, {
    key: "invert",
    value: function invert() {
      return new SetDocAttributeStep(this.key, this.previous, REVERT_STEP_TYPE);
    }
    /**
     * The position never changes so `map` should return the current step.
     */

  }, {
    key: "map",
    value: function map() {
      return this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        stepType: this.stepType,
        key: this.key,
        value: this.value
      };
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(_, json) {
      return new SetDocAttributeStep(json.key, json.value, json.stepType);
    }
  }]);

  return SetDocAttributeStep;
}(Step);

try {
  // Register the steps.
  Step.jsonID(STEP_TYPE, SetDocAttributeStep);
  Step.jsonID(REVERT_STEP_TYPE, SetDocAttributeStep);
} catch (error) {
  if (!error.message.startsWith("Duplicate use of step JSON ID")) {
    throw error;
  }
}

export { DocExtension };